import { RouteConfig } from "../../types/RouteConfig";
import { historyRoute } from "./history/route";
import { sendRoute } from "./send/route";

export const sendDocumentsRoutes: RouteConfig<'with-children'> = {
    name: 'Send Documents',
    icon: 'mdi mdi-email-open',
    children: [sendRoute, historyRoute],
}
